/* Shared resource library interactions */
if (!window.NetumSupportLibrariesLoaded) {
window.NetumSupportLibrariesLoaded = true;
(() => {
  const initializeResourceLibrary = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const search = root.querySelector('[data-resource-search]');
    const clear = root.querySelector('[data-resource-clear]');
    const product = root.querySelector('[data-resource-product]');
    const type = root.querySelector('[data-resource-type]');
    const platform = root.querySelector('[data-resource-platform]');
    const rows = [...root.querySelectorAll('[data-resource-row]')];
    const count = root.querySelector('[data-resource-count]');
    const noResults = root.querySelector('[data-resource-no-results]');
    const pagination = root.querySelector('[data-resource-pagination]');
    const pages = root.querySelector('[data-resource-pages]');
    const previous = root.querySelector('[data-resource-previous]');
    const next = root.querySelector('[data-resource-next]');
    const itemsPerPage = Math.max(1, Number(root.dataset.itemsPerPage) || 9);
    const initialModel = new URLSearchParams(window.location.search).get('model');
    if (search && initialModel && search.value.trim() === '') search.value = initialModel;
    const facets = [
      { name: 'product', select: product, matches: (row, value) => row.dataset.product === value },
      { name: 'type', select: type, matches: (row, value) => row.dataset.type === value },
      { name: 'platform', select: platform, matches: (row, value) => (row.dataset.platform || '').includes(value) },
    ].filter((facet) => facet.select);
    let currentPage = 1;

    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');

    const matchesRow = (row, excludedFacet = '') => {
      const query = normalize(search?.value);
      if (query && !normalize(row.dataset.search).includes(query)) return false;
      return facets.every((facet) => {
        if (facet.name === excludedFacet || facet.select.value === 'all') return true;
        return facet.matches(row, facet.select.value);
      });
    };

    const optionHasResults = (facet, value) => rows.some((row) => {
      if (!matchesRow(row, facet.name)) return false;
      return facet.matches(row, value);
    });

    const updateFacetOptions = (changedFacet = '') => {
      let selectionChanged = false;

      facets.forEach((facet) => {
        if (facet.name === changedFacet || facet.select.value === 'all') return;
        if (!optionHasResults(facet, facet.select.value)) {
          facet.select.value = 'all';
          selectionChanged = true;
        }
      });

      if (selectionChanged) updateFacetOptions(changedFacet);

      facets.forEach((facet) => {
        let availableOptions = 0;
        [...facet.select.options].forEach((option) => {
          if (option.value === 'all') {
            option.hidden = false;
            option.disabled = false;
            return;
          }
          const available = optionHasResults(facet, option.value);
          option.hidden = !available;
          option.disabled = !available;
          if (available) availableOptions += 1;
        });
        facet.select.disabled = availableOptions === 0;
        facet.select.setAttribute('aria-disabled', String(availableOptions === 0));
      });
    };

    const renderRows = (changedFacet = '') => {
      updateFacetOptions(changedFacet);
      const matches = rows.filter((row) => matchesRow(row));

      const totalPages = Math.ceil(matches.length / itemsPerPage);
      currentPage = Math.min(Math.max(currentPage, 1), Math.max(totalPages, 1));
      const visibleRows = new Set(matches.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage));
      rows.forEach((row) => { row.hidden = !visibleRows.has(row); });

      if (count) count.textContent = String(matches.length);
      if (noResults) noResults.hidden = matches.length !== 0;
      if (clear) clear.hidden = !search?.value;

      if (pagination && pages && previous && next) {
        pagination.hidden = totalPages <= 1;
        previous.disabled = currentPage <= 1;
        next.disabled = currentPage >= totalPages;
        pages.replaceChildren();
        for (let page = 1; page <= totalPages; page += 1) {
          const button = document.createElement('button');
          button.className = 'support-resource-library__page-button';
          button.type = 'button';
          button.textContent = String(page);
          button.dataset.resourcePage = String(page);
          button.setAttribute('aria-label', `Page ${page}`);
          if (page === currentPage) button.setAttribute('aria-current', 'page');
          pages.appendChild(button);
        }
      }
    };

    const resetAndRender = (changedFacet = '') => {
      currentPage = 1;
      renderRows(changedFacet);
    };

    search?.addEventListener('input', () => resetAndRender());
    product?.addEventListener('change', () => resetAndRender('product'));
    type?.addEventListener('change', () => resetAndRender('type'));
    platform?.addEventListener('change', () => resetAndRender('platform'));
    clear?.addEventListener('click', () => {
      search.value = '';
      search.focus();
      resetAndRender();
    });
    pagination?.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || button.disabled) return;
      if (button.matches('[data-resource-previous]')) currentPage -= 1;
      if (button.matches('[data-resource-next]')) currentPage += 1;
      if (button.dataset.resourcePage) currentPage = Number(button.dataset.resourcePage);
      renderRows();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.querySelector('[data-resource-list]')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
    renderRows();
  };

  document.querySelectorAll('[data-support-resource-library]').forEach(initializeResourceLibrary);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches?.('[data-support-resource-library]')
      ? event.target
      : event.target.querySelector?.('[data-support-resource-library]');
    initializeResourceLibrary(root);
  });
})();
}
